import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzNrday80 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_NRDAY_80: Record<
  Exclude<PageIdWoofzNrday80, PageIdWoofzNrday80.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageId.SUBSCRIPTIONS_NRDAY_80_N]: {
    id: PageId.SUBSCRIPTIONS_NRDAY_80_N,
  },
  [PageId.CHAT_UPSELL_NRDAY_80]: {
    id: PageId.CHAT_UPSELL_NRDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.UPSELL_NRDAY_80]: {
    id: PageId.UPSELL_NRDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageId.DOWNLOAD_NRDAY_80]: {
    id: PageId.DOWNLOAD_NRDAY_80,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
